import * as React from "react";
import {Field, InjectedFormProps, reduxForm} from "redux-form";
import {t} from "../../i18n";
import {connect} from "react-redux";
import {EMAIL_REGEXP_ALLOW_WILDCARD, PHONE_REGEX, renderFormField} from "../../user/ui/form";
import {
    Bundle,
    CurrencyDefinition,
    CustomerInfo,
    DepositResult,
    DepositResultCode, RegistrationRequest,
    Settings,
    UserInfo
} from "../../http/protocol";
import {AppState} from "../../RootReducer";
import {getContainer} from "../../ioc/IOCSetup";
import {Dispatch} from "redux";
import {TransactionTermsField} from "./TransactionTermsField";
import {isSendingPayment, isSendingPaymentFailed, showDepositResult} from "../../payments/DepositActions";
import {ButtonSpinner} from "../ButtonSpinner";
import "./styles/Deposit.scss";
import {STATES} from "./States";
import {COUNTRIES} from "./Countries";
import CurrencyFormatter from "../../utils/CurrencyFormatter";
import Big from "big.js";
import {isPasswordValid, isValid, matches} from "../../user/ui/utils";


const requiredText = (key : string) : string | any => {
    return t("forms.required", { label : t(key)});
}
const illegalChars = (key : string) : string | any => {
    return t("forms.illegal", { label : t(key)});
}

export const validateRegisterForm = (values : RegistrationRequest & {terms: boolean})=> {
    let error : any = {};
    let internal: any = Object.assign({}, values);
    let password = internal.pwd;
    let attributes = values.attributes;
    console.log("Attributes from validateRegisterForm; ", attributes, values)

    internal.pwd = password;
    if(!isValid(values.email,4,200)) {
        error.email = requiredText("email");
    }
    if(!values.email && !values.phoneNumber && !matches(values.email,EMAIL_REGEXP_ALLOW_WILDCARD)) {
        error.email = t("forms.email.invalid");
    } else if (!values.email && !matches(values.phoneNumber, PHONE_REGEX)) {
        error.phoneNumber = t("forms.phoneNumber.invalid");
    }
    if(!isPasswordValid(internal.pwd)) {
        error.password = t("forms.password.length");
    }
    if(!values.terms) {
        error.terms = t("forms.terms.invalid");
    }
    return error;
}

interface Props extends InjectedFormProps{
    paymentId: string;
    user: UserInfo;
    customContext: any;
    customerInfo:CustomerInfo;
    showDepositResult: typeof showDepositResult;
    sendingPayment: boolean;
    sendingPaymentFailed: boolean;
    paymentAmount: string;
    currency: string;
    bundles: Bundle[];
    selectedBundleId: number;
    settings: Settings;
    currencies: CurrencyDefinition[];
}

interface State {
    termsApproved: boolean;
    submitting: boolean;
    overLimit: boolean
}

export class UserIdentificationForm extends React.Component<Props, State>{

    constructor(props:Props) {
        super(props);
        this.state = {termsApproved: false, submitting: false, overLimit: false};
    }

    handleOnClick= () => {
        this.setState({termsApproved: !this.state.termsApproved});
    };

    componentDidMount(): void {
        const {customContext, paymentAmount} = this.props;
        if(customContext && customContext.pendingLimit && paymentAmount) {
            let waitingToClear = 0;
            if(customContext.amountWaitingToClear != undefined) {
                waitingToClear = customContext.amountWaitingToClear;
            }
            if((Number(paymentAmount) + Number(waitingToClear)) >= customContext.pendingLimit) {
                this.setState({overLimit:true})
            }
        }
    }

    renderDepositProduct() {
        let title = "Deposit";
        let product = "Amount";
        if(this.props.settings.useStoreInsteadOfDeposit) {
            title = "Purchase";
            if(this.props.bundles.length > 0 && this.props.selectedBundleId != null) {
                this.props.bundles.forEach((bundle) => {
                    if(bundle.id == this.props.selectedBundleId) {
                        product = bundle.name ? bundle.name : "Pack";
                    }
                })
            }
        }

        return (
                <div>
                    <div className="deposit-form top-text-mobile">
                        {title}
                    </div>
                    <div className="deposit-form product">
                        <div id="product-name" className="product">{product}</div>
                        <div id="price">{this.getFormattedAmount(Number(this.props.paymentAmount))}</div>
                    </div>
                </div>
        )
    }

    getFormattedAmount(amount:number) {
        let currencyDef = {};
        let bigAmount:Big = this.props.paymentAmount ? new Big(amount) : new Big(0);

        this.props.currencies.forEach((curr) => {
            if(curr.code == this.props.currency) {
                currencyDef = curr;
            }
        });

        return CurrencyFormatter.formatWithSymbol(currencyDef, bigAmount);

    }

    render() {
        const { customContext, paymentAmount } = this.props;
        if(customContext && customContext.resultCode == DepositResultCode.OVER_LIMIT || this.state.overLimit) {
            return (
                <div className="deposit-form">
                    <div>
                        <div className="deposit-form top-text-mobile text-center">{t(`payments.result.${DepositResultCode.OVER_LIMIT}.label`)}</div>
                        <p style={{textAlign:'center'}}>{t(`payments.result.${DepositResultCode.OVER_LIMIT}.message`)}</p>
                        {paymentAmount && <label className="deposit-form label">Payment Amount</label>}
                        {paymentAmount && <p>{this.getFormattedAmount(Number(paymentAmount))}</p>}
                        {customContext.amountWaitingToClear && <label className="deposit-form label">Amount Waiting To Clear</label>}
                        {customContext.amountWaitingToClear && <p>{this.getFormattedAmount(customContext.amountWaitingToClear)}</p>}
                        {customContext.pendingLimit && <label className="deposit-form label">Your Limit</label>}
                        {customContext.pendingLimit && <p>{this.getFormattedAmount(customContext.pendingLimit)}</p>}
                    </div>
                </div>
            )
        }
        if(customContext && customContext.achInformationRequired == false) {
            return (
                <form id="identificationForm" className="form deposit-form" onSubmit={this.props.handleSubmit} autoComplete="off">
                    {this.renderDepositProduct()}
                    <div className="top-text-mobile">Signer's Info</div>
                    {customContext.achPaymentDetails != undefined &&(
                        <div className="deposit-form">
                            <label className="deposit-form label">Signer name:</label>
                            <p className="right">{`${customContext.achPaymentDetails && customContext.achPaymentDetails.firstName} ${customContext.achPaymentDetails && customContext.achPaymentDetails.lastName}`}</p>
                            <label className="deposit-form label">Email:</label>
                            <p>{`${customContext.achPaymentDetails && customContext.achPaymentDetails.email}`}</p>
                            <label className="deposit-form label">Routing</label>
                            <p>{`${customContext.achPaymentDetails && customContext.achPaymentDetails.routingNumber}`}</p>
                            <label className="deposit-form label">Account No</label>
                            <p>{`${customContext.achPaymentDetails && customContext.achPaymentDetails.accountNumber}`}</p>
                        </div>
                    )}
                    <TransactionTermsField onClick={() => this.handleOnClick()}/>

                    {this.props.sendingPayment ? <button  className="submit-payment-button"><ButtonSpinner /></button> : false}
                    {!this.props.sendingPayment ?  <button id={"identificationForm"}  className="submit-payment-button" type="submit"  disabled={!this.state.termsApproved}>{t("forms.deposit")}</button> : false}

                </form>
            )
        } else if(customContext && customContext.achInformationRequired == true) {
            return (
                <form id="identificationForm" className="form deposit-form" onSubmit={this.props.handleSubmit} autoComplete="off">
                    {this.renderDepositProduct()}
                    <div className="top-text-mobile">Signer's Personal Data</div>
                    <Field props={{ label : "Signers First Name"}}
                           name="firstName"
                           hideHelp={"true"}
                           component={renderFormField} type="text"
                           required={true}/>
                    <Field props={{ label : "Signers Last Name"}}
                           name="lastName"
                           hideHelp={"true"}
                           component={renderFormField} type="text"
                           required={true}/>
                    <Field props={{ label : "Email Address"}}
                           name="email"
                           hideHelp={"true"}
                           component={renderFormField} type="text"
                           required={true}/>
                    <Field props={{ label : "Phone Number"}}
                           name="phone"
                           hideHelp={"true"}
                           component={renderFormField} type="text"
                           required={true}/>

                    <div className="top-text-mobile">Billing Address</div>
                    <Field props={{ label : "Address", help : "Street number and street name ex. \"123 Test Road\""}}
                           name="bank.accountAddress1"
                           component={renderFormField} type="text"
                           hideHelp={"true"}
                           required={true}/>
                    <Field props={{ label : "Suite/Apartment", help : "Optional"}}
                           name="bank.accountAddress2"
                           component={renderFormField} type="text"
                           hideHelp={"true"}
                           required={false}/>
                    <Field props={{ label : "City", help : "City name"}}
                           name="bank.accountCity"
                           component={renderFormField} type="text"
                           hideHelp={"true"}
                           required={true}/>
                    <label className="deposit-form label">Country</label>
                    <Field props={{ label : "Country", help : "Two character country code ex. \"US\""}}
                           name="bank.accountCountry"
                           component={"select"} type="text"
                           required={true}>
                        <option></option>
                        {COUNTRIES.map((c:any) => {
                            let key = Object.keys(c);
                            let value:string = key[0];
                            return <option className="deposit-form option" key={value} value={value}>{c[value]}</option>
                        })}
                    </Field>
                    <label className="deposit-form label">State</label>
                    <Field props={{ label : "State", help : "Two character state abbreviation ex \"CA\""}}
                           name="bank.accountState"
                           component={"select"} type="text"
                           hidehelp={"true"}
                           required={true}>
                        <option></option>
                        {STATES.map((c:any) => {
                            let key = Object.keys(c);
                            let value:string = key[0];
                            return <option className="deposit-form option" key={value} value={value}>{c[value]}</option>
                        })}
                    </Field>
                    <Field props={{ label : "Zip", help : "5-digit or 9-digit zip in the format 99999 or 99999-9999"}}
                           name="bank.accountZip"
                           component={renderFormField} type="text"
                           hideHelp={"true"}
                           required={true}/>

                    <div className="top-text-mobile">Checking Account Information</div>
                    <Field props={{ label : "Name On Account", help : "Should match the name on your bank account (can be personal or business name). For joint accounts, use only the signer's name here."}}
                           name="bank.accountCompanyName"
                           component={renderFormField} type="text"
                           required={true}/>
                    <Field props={{ label : "Routing Number", help : "9-digit routing number"}}
                           name="bank.routingNumber"
                           component={renderFormField} type="text"
                           required={true}/>
                    <Field className={""} props={{ label : "Account Number", help : "Bank account number"}}
                           name="bank.accountNumber"
                           component={renderFormField} type="text"
                           required={true}/>
                    <Field props={{ label : "Bank Name", help : "The name of the bank the checking account is with"}}
                           name="bank.name"
                           component={renderFormField} type="text"
                           required={true}/>
                    <TransactionTermsField onClick={() => this.handleOnClick()}/>
                    {this.props.sendingPayment ? <button  className="submit-payment-button"><ButtonSpinner /></button> : false}
                    {!this.props.sendingPayment ?  <button id={"identificationForm"}  className="submit-payment-button" type="submit"  disabled={!this.state.termsApproved}>{t("forms.deposit")}</button> : false}
                    {this.props.sendingPaymentFailed &&(<div className="deposit-form error-message">{t("forms.invalid-form")}</div>)}
                </form>
            )
        } else {
            return "";
        }
    }
}


const form = reduxForm({
    form: 'identificationForm',
    validate: validateRegisterForm,
    onSubmit : (req: CustomerInfo,dispatch:Dispatch, props: any) => {
        dispatch(isSendingPaymentFailed(false));
        if(props.sendingPayment == true) {
            return;
        }
        dispatch(isSendingPayment(true));
        let paymentId = props.paymentId;
        if(props.customContext.achInformationRequired == false) {

            getContainer().getPaymentsService().performDeposit(paymentId, undefined).then((response:DepositResult) => {
                dispatch(showDepositResult(response));
            }).catch((e)=>{
                console.log("Deposit failed du to the following error: ", e);
                // dispatch(showDepositResult({result:DepositResultCode.OK, paymentId:98769,referenceId:"65465135213"}))
                dispatch(isSendingPayment(false));
                dispatch(isSendingPaymentFailed(true));
            });
        }
        if(props.customContext.achInformationRequired == true) {

            let customerInfo:CustomerInfo = req;

            getContainer().getPaymentsService().performDeposit(paymentId, customerInfo).then((response:DepositResult) => {
                dispatch(showDepositResult(response));
            }).catch((e)=>{
                console.log("Deposit failed du to the following error: ", e);
                // dispatch(showDepositResult({result:DepositResultCode.OK, paymentId:98769,referenceId:"65465135213"}))
                dispatch(isSendingPayment(false));
                dispatch(isSendingPaymentFailed(true));
            });
        }

}
})(UserIdentificationForm as any);

const mapStateToProps = ({user, payments, store, settings}:AppState) => ({
    userUid : user.user && user.user.userUid,
    paymentId : payments.deposit.depositDialog && payments.deposit.depositDialog.payment && payments.deposit.depositDialog.payment.id,
    customerInfo : payments.deposit.depositDialog && payments.deposit.depositDialog.payment && payments.deposit.depositDialog.payment.order && payments.deposit.depositDialog.payment.order.customerInfo,
    customContext : payments.deposit.depositDialog && payments.deposit.depositDialog.customContext,
    sendingPayment : payments.deposit.sendingPayment,
    sendingPaymentFailed : payments.deposit.sendingPaymentFailed,
    paymentAmount : payments.deposit.amount,
    currency : payments.deposit.activeCurrency,
    bundles : store.bundles && store.bundles.items,
    selectedBundleId : store.selectedBundleId,
    settings : settings.settings,
    currencies : user.user && user.user.currencies
});

export default connect(mapStateToProps)(form);

